import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'tdesign-react';
import EnvSelectCmp from '@/components/Cluster/EnvSelect';

const { FormItem } = Form;

function EnvSelect({ clusterEnvs }) {
  return (
    <>
      <FormItem name='clusterEnv'>
        <EnvSelectCmp options={clusterEnvs} />
      </FormItem>
    </>
  );
}

export default connect((state) => ({
  clusterEnvs: state.cluster.clusterEnvs,
}))(EnvSelect);
